export class FacturationResponse {


    public status: String;
    public erreursBloquantes: Array<String>;
    public erreursNonBloquantes: Array<String>;

    constructor() {

    }

}
